import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const OperRoute = () => {
  const { user, cargando } = useAuth();

  if (cargando) return <div>Cargando...</div>;

  // Permitir acceso si el rol es "oper" o "admin"
  return user && (user.role === "oper" || user.role === "admin") ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default OperRoute;
